import { render, staticRenderFns } from "./KitChip.vue?vue&type=template&id=123db5ec&scoped=true&"
import script from "./KitChip.vue?vue&type=script&lang=ts&"
export * from "./KitChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123db5ec",
  null
  
)

export default component.exports